import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useMutation } from '@tanstack/react-query';

import ScoreCardDeleteModal from './ScoreCardDeleteModal';
import { Edit, Delete, Email, History } from '../../../assets/svg';
import { SCORECARD_REPORT, ROUTES, INFO } from '../../../constants';
import { ConfirmationBox } from '../../shared';
import { popup, sendReport } from '../../../utils';
import EmailReportModal from '../../shared/Modal/EmailReportModal';

export const AdminScoreCardListingOperation = ({ data }) => {
    const navigate = useNavigate();
    const [isDeleteModal, setIsDeleteModal] = useState(false);
    const [showReportModal, setShowReportModal] = useState(false);
    const [selectedData, setSelected] = useState({});
    const { isUserAdmin } = useSelector((s) => s.user);

    const [openConfirmationBox, setOpenConfirmationBox] = useState(false);
    const [accountId, setAccountId] = useState(null);

    const handleEditClick = (editData) => {
        navigate(ROUTES.ADMIN.SCORE_CARD_REPORT_ADMIN, {
            state: {
                accountUserDetails: {
                    id: editData.account_id,
                    name: editData.account_name,
                    platform_id: editData.platform_id,
                    grade: editData.grade,
                },
            },
        });
    };

    const handleDeleteModalClick = (data) => {
        setSelected(data);
        setIsDeleteModal(true);
    };

    const handleSendReport = async (account_id) => {
        setOpenConfirmationBox(true);
        setAccountId(account_id);
    };

    const sendEmailMutation = useMutation({
        mutationFn: async () => await sendReport({ id: accountId }),
        onSuccess: () => popup('success', INFO.SEND_REPORT_CSM),
        onError: (error) => popup('error', error.message || INFO.NO_PRIMARY_USER),
    });

    const sendEmail = (confirm) => {
        if (confirm) sendEmailMutation.mutate();
    };

    return (
        <div className='d-flex align-items-center justify-content-start gap-2'>
            <button
                id='action-btn'
                className='border-0 p-0 bg-white'
                type='button'
                data-bs-toggle='modal'
                data-bs-target='#exampleModal-edit'
                onClick={() => handleEditClick(data)}
                title='Edit'
            >
                <Edit />
            </button>

            <button
                id='action-btn'
                className='border-0 p-0 bg-white'
                type='button'
                data-bs-toggle='modal'
                data-bs-target='#exampleModal-del'
                onClick={() => handleDeleteModalClick(data)}
                title='Delete'
            >
                <Delete />
            </button>
            {isUserAdmin && (
                <button
                    id='action-btn'
                    className='border-0 p-0 bg-white'
                    type='button'
                    data-bs-toggle='modal'
                    data-bs-target='#exampleModal-del'
                    onClick={() => handleSendReport(data.account_id)}
                    disabled={sendEmailMutation.isPending}
                    title='Send Report'
                >
                    <Email />
                </button>
            )}
            {isUserAdmin && (
                <button
                    className='border-0 p-0 bg-white text-bg-light'
                    type='button'
                    data-bs-toggle='modal'
                    data-bs-target='#exampleModal-del'
                    onClick={() => setShowReportModal(true)}
                    title='View Report Archive'
                    id='action-btn'
                >
                    <History />
                </button>
            )}
            {isDeleteModal && (
                <ScoreCardDeleteModal
                    isDeleteScorecardByAccountAndPlatform={true}
                    isDeleteModal={isDeleteModal}
                    setIsDeleteModal={setIsDeleteModal}
                    selectedData={selectedData}
                    deleteButtonName={SCORECARD_REPORT.SCORE_CARD_LISTING_PAGE.DELETE_BUTTON}
                />
            )}
            {showReportModal && (
                <EmailReportModal
                    showModal={showReportModal}
                    setShowModal={setShowReportModal}
                    accountId={data?.account_id}
                />
            )}
            {openConfirmationBox && (
                <ConfirmationBox
                    setConfirm={(val) => sendEmail(val)}
                    openConfirmationBox={openConfirmationBox}
                    setOpenConfirmationBox={setOpenConfirmationBox}
                    customMessage={INFO.CONFIRM_SEND_REPORT}
                />
            )}
        </div>
    );
};

AdminScoreCardListingOperation.propTypes = {
    data: PropTypes.shape({
        account_id: PropTypes.string.isRequired,
        account_name: PropTypes.string.isRequired,
    }).isRequired,
    debouncedApiCall: PropTypes.func,
};
